<template>
  <generic-shipment-view 
      v-bind:my-shipment="this.myShipmentData"
      @failedLoad="failedLoad"
      v-if="(gotId && showShipmentView)"
  />
  <IndexView @clicked="search"
             v-bind:error-message="this.errorMessage"
             v-bind:error-occured="this.errorOccured"
             v-bind:is-loading="this.isLoading"
             v-else
             />
</template>

<script>
import IndexView from "@/components/IndexView";
import genericShipmentView from "@/components/genericShipmentView";
import shipmentApi from '../Services/httpService'


export default {
  name: "viewSwitcher",
  components: {IndexView, genericShipmentView},
  props: {},
  data: function () {
    return {
      gotId: false,
      showShipmentView: false,
      errorMessage: '',
      errorOccured: false,
      isLoading: false,
      myShipmentData: {},
      requestedCommand: 'generic-shipment-view'
    }
  },
  async mounted() {

      if (window.location.pathname.startsWith('/p/locateshipment/')) {

          const segments = window.location.pathname.split('/');
          const customerExternalId = segments[3];
          const waybillExternalId = segments[4];

          if(segments.length > 5)
            this.requestedCommand = segments[5];
          
          this.locateMyShipment(customerExternalId, waybillExternalId);

      } else if (window.location.pathname.startsWith('/p/locatereference/')) {

          const customerExternalId = window.location.pathname.split('/')[3];
          const alternateExternalWaybillID = window.location.pathname.split('/')[4];

          this.locateMyShipmentByAlternateExternalWaybillID(customerExternalId, alternateExternalWaybillID);

      } else {

          const id = window.location.pathname.split('/')[1];

          if (/\S/.test(id)) {
              this.loadMyShipment(id);
          }
      }

  },
  methods: {
    search(inputValue)
    {
      if (/\S/.test(inputValue)) {
        window.history.pushState('', '', '/'+ inputValue);
        this.loadMyShipment(inputValue)
      }
    },
    failedLoad(statusCode)
    {
      if (statusCode === 404)
      {
        this.errorMessage = this.$t("errorCode.404")
      }
      else if (statusCode === 500)
      {
        this.errorMessage = this.$t("errorCode.500")
      }
      else
      {
        this.errorMessage = this.$t("errorCode.unknown")
      }
      this.errorOccured = true
      this.gotId = false
    },
    loadMyShipment(id)
    {
      this.isLoading = true;
      shipmentApi.get("api/myshipment/" + id)
          .then((response) => {
            this.errorOccured = false
            this.isLoading = false;
            this.myShipmentData = response.data
            this.gotId = true;
            this.showShipmentView = true;
          })
          .catch((error) => {
            this.isLoading = false;
            this.failedLoad(error.response.status)
          })
      },
      locateMyShipment(customerExternalId, waybillExternalId) {
          this.isLoading = true;

          shipmentApi.get("api/myshipment/ByExternalWaybill/" + customerExternalId + '/' + waybillExternalId)
              .then((response) => {
                  this.errorOccured = false
                  this.isLoading = false;
                  this.myShipmentData = response.data
                  this.gotId = true;
                  this.handleResponse();
              })
              .catch((error) => {
                  this.isLoading = false;
                  this.failedLoad(error.response.status)
              })
      },

      locateMyShipmentByAlternateExternalWaybillID(customerExternalId, alternateExternalWaybillId) {

          this.isLoading = true;

          shipmentApi.get("api/myshipment/ByAlternateExternalWaybill/" + customerExternalId + '/' + alternateExternalWaybillId)
              .then((response) => {
                  this.errorOccured = false
                  this.isLoading = false;
                  this.myShipmentData = response.data
                  this.gotId = true;
                  this.handleResponse();
              })
              .catch((error) => {
                  this.isLoading = false;
                  this.failedLoad(error.response.status)
              })
      },

      handleResponse() {
      
        console.log(this.requestedCommand);
        if(this.requestedCommand === 'generic-shipment-view')
          this.showShipmentView = true;
        
        else if(this.requestedCommand === 'carrier-tracking' && this.myShipmentData.trackAndTraceLinks[0].trackingLink){
          this.navigateToTrackingLink(this.myShipmentData.trackAndTraceLinks[0].trackingLink)
        }else if(this.requestedCommand === 'carrier-tracking') {
          this.failedLoad("Could not find Shipment Tracking Link. Try again later.")
        }
          
      },
    
    
      navigateToTrackingLink(trackingLink) {
        window.location.href = trackingLink;
      }

  },
  computed: {
   
  },
  filters: {}
}

</script>

<style scoped>

</style>